const SignalRErrorCodes = {
  SIGNALR_NEGOTIATE_ERROR: 'SR-2000',
};

Object.freeze(SignalRErrorCodes);

export default SignalRErrorCodes;
